export enum category {
    NOTICIA = "Notícia",
    BLOG = "Blog"
}